import { jsx as _jsx } from "react/jsx-runtime";
const estilos = {
    info: 'bg-marca-50 text-marca-900 dark:bg-marca-950 dark:text-marca-100',
    sucesso: 'bg-green-50 text-green-900 dark:bg-green-950 dark:text-green-100',
    atencao: 'bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-100',
    erro: 'bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-100',
};
export function Aviso({ tipo = 'info', children, className = '', }) {
    return (_jsx("div", { role: tipo === 'erro' ? 'alert' : 'status', className: `rounded-lg px-3 py-2 text-sm ${estilos[tipo]} ${className}`, children: children }));
}
//# sourceMappingURL=Aviso.js.map